/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { apuUsdkGetChannelOnlineConfig } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import ConfigShare from './configShare.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'name'
    }, {
      label: '操作',
      action: true,
      width: '200px'
    }];
    const filter = ref({
      cid: undefined,
      name: ''
    });
    const configShareRef = ref();
    const getTableData = () => {
      tableLoading.value = true;
      apuUsdkGetChannelOnlineConfig({
        gid: gameInfo.value.Id,
        ...filter.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const activeTable = computed(() => {
      if (!filter.value.cid) {
        return tableData.value;
      }
      return tableData.value.filter(item => item.cid === filter.value.cid);
    });
    const handleClick = row => {
      configShareRef.value.show({
        gid: gameInfo.value.Id,
        channel: row
      });
    };
    watch(() => gameInfo.value.Id, val => {
      if (val) {
        getTableData();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "选择渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_game_channel_select, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
            clearable: "",
            gid: _unref(gameInfo).Id
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(UTable, {
        options: columns,
        "row-key": "cid",
        pagination: "",
        data: _unref(activeTable),
        loading: _unref(tableLoading)
      }, {
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("配置")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading"]), _createVNode(ConfigShare, {
        ref_key: "configShareRef",
        ref: configShareRef,
        onOk: getTableData
      }, null, 512)]);
    };
  }
});